// extracted by mini-css-extract-plugin
export default {"action-type-label":"rx1Ama","action-type-icon-container":"vCjg50","is-color-teal":"AvGGtu"};